export const capitalize = (str: string): string => {
  return str && str.charAt(0).toUpperCase() + str.slice(1)
}

export const capitalizeEachWord = (str: string): string => {
  return str
    .split(' ')
    .map(word => capitalize(word))
    .join(' ')
}

/**
 * Normalize a string by trimming and converting to lowercase
 */
export const normalizeString = (value: string): string => value.trim().toLowerCase()

/**
 * Convert string to slug-safe string.
 * @param {string} args
 * @returns {string}
 */
export const slugify = (...args: string[]): string => {
  const value = args.join(' ')

  return (
    value
      ?.normalize('NFD') // split an accented letter in the base letter and the accent
      .replaceAll(/[\u0300-\u036F]/g, '') // remove all previously split accents
      .toLowerCase()
      .trim()
      .replaceAll(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
      .replaceAll(/\s+/g, '-') ?? '' // separator
  )
}

export function isEnumMember<E extends string>(
  value: unknown,
  enumObject: Record<string, E>,
): value is E {
  return Object.values(enumObject).includes(value as E)
}

/**
 * Generate a random key for React elements.
 * Uses Math.random() to create a simple alphanumeric string.
 * @returns {string} Random key string
 */
export const generateRandomKey = (): string => {
  return Math.random().toString(36).slice(2, 11)
}
